module.exports = __webpack_public_path__ + "img/2-6.ee72dd70.png";